import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-174f655c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tabs-container" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["onClick"]

import { watch, computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { TabsState } from '@/store/tabs'


export default /*#__PURE__*/_defineComponent({
  __name: 'TabsView',
  props: {
  isCollapse: {
    type: Boolean,
    default: false
  }
},
  setup(__props) {

const props = __props;

const route = useRoute()
const router = useRouter()
const store = useStore()



const visitedViews = computed(() => {
  console.log('visitedViews',store.state);
  
  return store.state.tabs ? (store.state.tabs as TabsState).visitedViews : []
})

const activeTab = computed(() => {
  return store.state.tabs ? (store.state.tabs as TabsState).activeTab : ''
})

// 移除标签
const removeTab = (targetPath: string) => {
  const activePath = store.dispatch('tabs/removeTab', targetPath)
  if (activePath) {
    router.push(activePath)
  }
}

// 标签点击
const handleClick = (tab: any) => {
  router.push(tab.path)
}

// 监听路由变化
watch(
  () => route.path,
  () => {
    store.dispatch('tabs/setActiveTab', route.path)
    store.dispatch('tabs/addTab', {
      path: route.path,
      meta: route.meta
    })
  },
  { immediate: true }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "tabs-view",
    style: _normalizeStyle({ left: __props.isCollapse ? '65px' : '200px' })
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(visitedViews), (item) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item.path,
          class: _normalizeClass(["tab-item", { 'active': _unref(activeTab) === item.path }]),
          onClick: ($event: any) => (handleClick(item))
        }, [
          _createElementVNode("span", null, _toDisplayString(item.meta.title), 1),
          (item.path !== '/Home')
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: "close-icon",
                onClick: _withModifiers(($event: any) => (removeTab(item.path)), ["stop"])
              }, "×", 8, _hoisted_3))
            : _createCommentVNode("", true)
        ], 10, _hoisted_2))
      }), 128))
    ])
  ], 4))
}
}

})